var map = {
	"./music-instructions.json": 4550,
	"./music-library-intro2024.json": 4551,
	"./music-library-launch2024.json": 4552,
	"./music-progression.json": 4553,
	"./startSourcesAdvanced.json": 4554,
	"./startSourcesSimple.json": 4555,
	"./startSourcesSimple2.json": 4556,
	"./startSourcesTracks.json": 4557
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4318;